import React from "react";
import CellphoneFrame from "../Assets/Images/CellphoneFrame.png";

import CsTopProfile from "../Assets/Images/top-feed.png"
import PullRefresh from "../Assets/Images/pull-refresh.png"
import EventTime from "../Assets/Images/event-time.svg"
import IdleState from "../Assets/Images/idle-state.svg"
import CalendarCheck from "../Assets/Images/calendartick.png"

const IphoneScreen2 = (props) => {
  const { backgroundBase, SecundaryBackground, btnColor, btnFont, font, eventTitleColor } = props;
  const styles = {
    container: {
      position: "relative",
      maxWidth: "234px",
      minWidth: "234px",
    },
    imageOverlay: {
      width: "100%",
      height: "auto",
      position: "absolute",
      left: 0
    },
    containerFrame: {
      backgroundColor: backgroundBase || "#F0F0F4",
      color: font || "#F0F0F4",
    },
    text: {
      fontSize: "12px",
    },
    description: {
      display: "flex",
      justifyContent: "center",
    },
    topLogin: {
      backgroundColor: SecundaryBackground || "#999",
    },
    eventBanner: {
      backgroundColor: SecundaryBackground || "#999",
    },
    eventTitle: {
      color: eventTitleColor || "#999",
    },
    logOutBtn: {
      backgroundColor: btnColor || "#CCC",
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.container} className="feed-demo">
        <img src={CellphoneFrame} style={styles.imageOverlay} />
        <div style={styles.containerFrame} className="internal-phone-frame">
          <div className="top-app-demo" style={styles.topLogin}>
            <img className="client-top-profile" src={CsTopProfile} />
            <div className="logout-btn" style={styles.logOutBtn}></div>
          </div>
          <div className="pull-refresh">
            <img src={PullRefresh} />
          </div>
          <div className="bottom-app-demo">
            <div className="event-card">
              <div className="event-banner" style={styles.eventBanner}>
                <img src={CalendarCheck} />
              </div>
              <div className="card-body">
                <div className="meta-event">
                  <h5 style={styles.eventTitle}>Sunday Servie 9:30 am</h5>
                  <img src={EventTime} /> 
                </div>
                <img src={IdleState} className="event-idle" /> 
              </div>
            </div>
            <div className="event-card">
              <div className="event-banner" style={styles.eventBanner}>
                <img src={CalendarCheck} />
              </div>
              <div className="card-body">
                <div className="meta-event">
                  <h5 style={styles.eventTitle}>Sunday Servie 11:00 am</h5>
                  <img src={EventTime} /> 
                </div>
                <img src={IdleState} className="event-idle" /> 
              </div>
            </div>
          </div>
        </div>
      </div>
      <h4 className="phone-label" style={styles.description}>{props.description}</h4>
    </div>
  );
};

export default IphoneScreen2;
